/**
 * Model representing a network group
 */
export class GrupoRede {
  constructor(
    public readonly descricaoGrupo: string,
    public readonly codigoGrupo: string
  ) {}

  static fromJson(json: any): GrupoRede {
    return new GrupoRede(json.descricaoGrupo, json.codigoGrupo);
  }
}

/**
 * Filter model for network group search
 */
export class GrupoRedeFilter {
  constructor(
    public readonly coluna: number,
    public readonly operador: number,
    public readonly parametro: string
  ) {}

  toJson(): any {
    return {
      coluna: this.coluna,
      operador: this.operador,
      parametro: this.parametro,
    };
  }
}
